// extracted by mini-css-extract-plugin
export var sliderRange = "_py-2";
export var sliderRoot = "_py-0";
export var sliderThumb = "_py-3";
export var sliderTrack = "_py-1";